import { AuthenticationData } from '../store/authentication';
import { apiClient } from './apiClient';

export type NorskGjeldResponse = {
    consentUrl: string;
};

export const initNorskGjeldService = async (
    apiProxyPath: string,
    apiKey: string,
    governmentId: string,
    successRedirectUrl: string,
    failureRedirectUrl: string,
    authenticationData?: AuthenticationData,
): Promise<NorskGjeldResponse> => {
    return apiClient<NorskGjeldResponse>(`${apiProxyPath}/debts/consent`, {
        method: 'POST',
        body: { governmentId, successRedirectUrl, failureRedirectUrl },
        apiKey,
        authenticationData,
        sentryTag: 'init_norsk_gjeld',
    });
};
